/**
 * Created by Rami on 7/28/2016.
 */
(function () {

    "use strict";
    angular.module("harriApp")
        .directive('employeeProfile', ['$filter', 'hUser', function ($filter, hUser) {
            return {
                restrict: "E",
                replace: 'true',
                scope: {
                    brandId: '=',
                    member: '='
                },
                templateUrl: '../modules/team_schedule/common/views/employee_profile_directive.html',
                link: function ($scope, element, attrs) {
                    $scope.user = hUser.getUser();
                }
            };
        }]);
})();
